import { useTypedSelector } from '../../redux/rootReducer'
import { selectUserData } from '../../redux/User/selector'

export function useLoggedInUser() {
  return useTypedSelector(selectUserData)
}
